import React, { Component } from 'react';
import KubanComp from '../../components/kuban/kubanComp';
class TaskList extends Component {
    render() {
        return (
            <div>
                <KubanComp />
            </div>
        );
    }
}

export default TaskList;